"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImageResponse = uploadImageResponse;
async function uploadImageResponse(authHeader, formData, purpose) {
    const url = `https://devapi.gogig.in/fileUploader?category=${purpose.category}&gigId=${purpose.gigId}`;
    const headers = {
        Authorization: authHeader,
    };
    return await fetch(url, {
        method: 'POST',
        headers: headers,
        body: formData,
    });
}
